<template>
	<div class="app flex-row align-items-center">
		<div class="error-info">
			<h3>404</h3>
      <Logo/>
			<p>Aradığınız sayfayı bulamadık, doğru bir sayfa aradığınızdan emin misiniz?</p>
			<div class="routers" v-if="!isMobile">
				<div class="row row-wrap">
					<div class="col" :class="isMobile ? 'col-6' : 'col-2'">
						<router-link class="item" :to="{ name: 'Sportsbook'}">
							<div class="icon sportbook"></div>
							<h2>Spor</h2>
							<p>Bahisleri</p>
						</router-link>
					</div>
					<div class="col" :class="isMobile ? 'col-6' : 'col-2'">
						<router-link class="item" :to="{ name: 'Live'}">
							<div class="icon live"></div>
							<h2>Canlı</h2>
							<p>Bahisler</p>
						</router-link>
					</div>
					<div class="col" :class="isMobile ? 'col-6' : 'col-2'">
						<router-link class="item" :to="{ name: 'Slot'}">
							<div class="icon slot"></div>
							<h2>Slot</h2>
							<p>Oyunları</p>
						</router-link>
					</div>
					<div class="col" :class="isMobile ? 'col-6' : 'col-2'">
						<router-link class="item" :to="{ name: 'Casino'}">
							<div class="icon casino"></div>
							<h2>Canlı</h2>
							<p>Casino</p>
						</router-link>
					</div>
					<div class="col" :class="isMobile ? 'col-6' : 'col-2'">
						<router-link class="item" :to="{ name: 'Bingo'}">
							<div class="icon bingo"></div>
							<h2>Tombala</h2>
							<p>Oyna</p>
						</router-link>
					</div>
					<div class="col" :class="isMobile ? 'col-6' : 'col-2'">
						<router-link class="item" :to="{ name: 'Zeppelin'}">
							<div class="icon zeppelin"></div>
							<h2>Zeplin</h2>
							<p>Oyna</p>
						</router-link>
					</div>
				</div> 
			</div>
		</div>
	</div>
</template>
<style>
</style>
<script>
import Logo from '../../components/Common/Header/Logo'
export default {
  name: 'NotFound',
	metaInfo () {
			return {
			title: '404 | ' + _.get(this.$store.getters['getClientMeta'], 'main.title', ''),
			}
	},
  components:{
    Logo
  }
}
</script>